/* Imports */
import React from "react"
import { Cover, Font } from "fajny-react"

import LayoutCover from "../../components/LayoutCover"

const DemoCoverBottomOverlay = () => {
    return (
        <LayoutCover title="Cover bottom overlay">
            <Cover src="/images/cover-parallax.jpg" alt="Cover" align="bottom" overlay>
                <Font.H1 display>Title</Font.H1>
                <Font.H2 display>Subtitle</Font.H2>
            </Cover>
        </LayoutCover>
    )
}

export default DemoCoverBottomOverlay
